import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';

/**
 * 404 / page-not-found screen (PLAN-2069).
 *
 * Rendered for the catch-all route. Shows a friendly "page not found" card with actions to go
 * back or return home. Carries no internal detail.
 */
@Component({
  selector: 'gains-not-found-screen',
  standalone: true,
  imports: [AngularSvgIconModule, NzButtonModule],
  templateUrl: './not-found-screen.component.html',
  styleUrl: './not-found-screen.component.scss'
})
export class NotFoundScreenComponent {
  constructor(
    private readonly _router: Router,
    private readonly _location: Location
  ) {}

  goBack(): void {
    this._location.back();
  }

  goHome(): void {
    this._router.navigate(['/home']);
  }
}
